module.exports = "<a class=\"btn\" (click)=\"close()\" float-right><ion-icon name=\"close\"></ion-icon></a>\n<div id=\"content\"></div>\n"